import { create } from "zustand";
import { User } from "@/types/auth";

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isAuthChecked: boolean;
  setAuth: (user: User, token?: string | null) => void;
  setAuthChecked: (checked: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  token: null,
  isAuthenticated: false,
  isAuthChecked: false,
  setAuth: (user, token) => set({
    user,
    token: token === undefined ? get().token : token,
    isAuthenticated: true,
    isAuthChecked: true,
  }),
  setAuthChecked: (checked) => set({ isAuthChecked: checked }),
  logout: () => set({
    user: null,
    token: null,
    isAuthenticated: false,
    isAuthChecked: true,
  }),
}));
